'use strict';

class EventPipe {
  constructor() {
    this.eventsHash = new Map();
  }

  on(eventName, cb) {
    const currentEvent = this.eventsHash.get(eventName) || new Set();
    currentEvent.add(cb);
    this.eventsHash.set(eventName, currentEvent);
  }

  off(eventName, cb) {
    if (cb) {
      this.eventsHash.get(eventName).delete(cb);
    } else {
      this.eventsHash.delete(eventName);
    }
  }

  trigger(eventName, ...params) {
    const returnValues = {};
    if (this.eventsHash.has(eventName)) {
      this.eventsHash.get(eventName).forEach(fn => {
        const result = fn(...params);
        Object.assign(returnValues, result);
      });
    }
    return returnValues;
  }

  once(eventName, cb) {
    const boundOff = this.off.bind(this);
    const onceCb = () => {
      cb(...arguments);
      boundOff(eventName);
    };
    this.on(eventName, onceCb);
  }
}

EventPipe.init = function (payload, done) {
  window.DealEventPipe = new EventPipe();
  return done();
};

window.EventPipe = EventPipe;
module.exports = EventPipe;
